import React from 'react'
import PropTypes from 'prop-types'
import Badge from '../Badge'

import regionColorMap from 'components-design-system/badges/regionColorMap'

export { regionColorMap }

const RegistryBadge = ({
  value,
  registries,
  style,
}) => {
  const badgeValue = React.useMemo(() => {
    if (!registries) return null
    return registries.reduce((acc, regObj) => {
      if (regObj.name === value) {
        acc = regObj.badge || value
      }
      return acc
    }, value)
  }, [value])

  const region = React.useMemo(() => {
    if (!registries) return null
    return registries.find((regObj) => regObj.name === value)?.gpr_continent
  }, [value])

  const tooltip = React.useMemo(() => {
    if (!registries) return null
    return registries.reduce((acc, regObj) => {
      if (regObj.name === value) acc = `${value} (${regObj.region_name})`;
      return acc
    }, '')
  }, [value])

  return <Badge
    value={badgeValue}
    colorName={regionColorMap[region]}
    tooltipText={tooltip}
    style={style}
  />
}

RegistryBadge.propTypes = {
  value: PropTypes.string,
  registries: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    badge: PropTypes.string, // nickname
    region_name: PropTypes.string, // country/continent
    gpr_continent: PropTypes.oneOf([
      "Internal",
      "africa",
      "americas",
      "asia",
      "europe",
      "mideast",
      "oceania",
      null,
    ]),
  })),
  style: PropTypes.object,
}

export default RegistryBadge